var _circle, _path, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle3, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.5,
    r: 3.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21c0-3.5 3.2-6.5 7-6.5s7 3 7 6.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2.8,
    stroke: "currentColor",
    strokeWidth: 1.2,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.2,
    x2: 5,
    y2: 3.5,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 6.5,
    x2: 5,
    y2: 7.8,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.2,
    y1: 5,
    x2: 3.5,
    y2: 5,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 5,
    x2: 7.8,
    y2: 5,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.2,
    y1: 3.2,
    x2: 4.2,
    y2: 4.2,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 5.8,
    y1: 3.2,
    x2: 4.8,
    y2: 4.2,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5.8,
    y1: 6.8,
    x2: 4.8,
    y2: 5.8,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 3.2,
    y1: 6.8,
    x2: 4.2,
    y2: 5.8,
    stroke: "currentColor",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 3.5,
    x2: 19,
    y2: 4.6,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7.4,
    x2: 19,
    y2: 8.5,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 6,
    x2: 17.6,
    y2: 6,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 20.4,
    y1: 6,
    x2: 21.5,
    y2: 6,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 17.1,
    y1: 4.4,
    x2: 17.9,
    y2: 5.2,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 20.9,
    y1: 4.4,
    x2: 20.1,
    y2: 5.2,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 20.9,
    y1: 7.6,
    x2: 20.1,
    y2: 6.8,
    stroke: "currentColor",
    strokeWidth: 0.9
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 17.1,
    y1: 7.6,
    x2: 17.9,
    y2: 6.8,
    stroke: "currentColor",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.c34a182fe47b426a710d79214379c883.svg";
export { ForwardRef as ReactComponent };